"use client";

import { Alert, Button } from "antd";

import { ServicePricingSelectionError } from "@/lib/api/openingsLocations";

import { useRepricedServices } from "../useRepricedServices";

/**
 * The one customer-facing state for an authoritative cross-business price
 * lookup. Consumers also block their actions while this is visible; the alert
 * makes that wait/error explicit and gives a failed lookup a local retry.
 */
const ServicePricingStatus = () => {
  const pricing = useRepricedServices();

  if (pricing.status === "ready") return null;

  if (pricing.status === "pending") {
    return (
      <Alert
        type="info"
        showIcon
        title="Confirming current pricing…"
        description="Please wait before continuing with your appointment."
      />
    );
  }

  // The adapter throws typed, deterministic reasons ("Selected service is
  // unavailable at this location."); hiding them behind generic try-again
  // copy presents a permanent mismatch as a transient outage. ONLY those
  // typed messages are written for customers — raw network/upstream errors
  // must never render.
  const reason =
    pricing.error instanceof ServicePricingSelectionError
      ? pricing.error.message
      : "";

  return (
    <Alert
      type="error"
      showIcon
      title="We couldn’t confirm current pricing."
      description={
        reason
          ? `${reason} No booking or payment decision was made.`
          : "No booking or payment decision was made. Try again to continue."
      }
      action={
        <Button size="small" onClick={pricing.retry}>
          Retry pricing
        </Button>
      }
    />
  );
};

export default ServicePricingStatus;
